import React from 'react'
import getDeviceType from 'lib/utils/getDeviceType'
import Box from '@material-ui/core/Box'
import CloseIcon from 'components/material-symbol/icons/Close'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import IconButton from '@material-ui/core/IconButton'
import { useTheme } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import useStyles from './styles'

const SmartBannerAd = ({
  appIcon,
  appStoreUrl,
  titleText,
  subtitleText,
  ctaText,
  handleCtaClick,
  handleDismiss,
  top,
}) => {
  const classes = useStyles({ top })
  const deviceType = getDeviceType()

  const isMobile = useMediaQuery(useTheme().breakpoints.down('sm'))
  if (deviceType === 'unknown' || !isMobile) return null

  return (
    <Box className={classes.root}>
      <IconButton
        aria-label={`Dismiss ${titleText} app banner`}
        onClick={handleDismiss}
        className={classes.dismissButton}
      >
        <CloseIcon />
      </IconButton>
      <img src={appIcon} alt="" className={classes.appIcon} />
      <Box className={classes.text}>
        <Typography className={classes.titleText} noWrap>
          {titleText}
        </Typography>
        <Typography className={classes.subtitleText} noWrap>
          {subtitleText}
        </Typography>
      </Box>
      <Button
        variant="contained"
        color="primary"
        onClick={handleCtaClick}
        className={classes.ctaButton}
      >
        {ctaText}
      </Button>
    </Box>
  )
}

export default SmartBannerAd
